import React from 'react';
import cx from 'classnames';
import _get from 'lodash/get';
import { FormattedMessage } from 'react-intl';
import Img from 'components/Image';
import hexColoredSmall from 'utils/images/hex-colored-small.svg';
import WL from 'constants/whiteLabel';
import MODELS from 'constants/asicModels';
import gs from 'pages/pages.module.css';
import s from 'pages/homeStyles.module.css'
import style from './overclock.module.css';

const Overclock = props => (
  <section className={cx(style.root, gs.content, s.hiveosContent, s.alternate)}>
    {WL.showHexImg ? <img alt="hex" className={cx(s.drop1, s.__beInControl)} src={hexColoredSmall} /> : null}
    <div className={gs.backgroundHeader}>overclock</div>
    <div className={cx(gs.wrapper, s.wrapper)}>
      <div className={gs.relative}>
        <div className={style.transfromToRight}>
          {props.selected === _get(MODELS, 'S17.key') && <Img className={style.screen} src="hash-chart_s17.png" alt="overclock" />}
          {props.selected === _get(MODELS, 'T17.key') && <Img className={style.screen} src="hash-chart_t17.png" alt="overclock" />}
          {props.selected === _get(MODELS, 'S10.key') && <Img className={style.screen} src="hash-chart_s10.png" alt="overclock" />}
          {props.selected === _get(MODELS, 'S9.key') && <Img className={style.screen} src="overclock.png" alt="overclock" />}
          {props.selected === _get(MODELS, 'T9.key') && <Img className={style.screen} src="hash-chart_t9.png" alt="overclock" />}
          {props.selected === _get(MODELS, 'L3.key') && <Img className={style.screen} src="hash-chart_l3.png" alt="overclock" />}
        </div>
      </div>
      <div className={style.text}>
        <h2><FormattedMessage id="Overclock.title" defaultMessage="ASIC Chips Overclocking" /></h2>
        <div><FormattedMessage id="Overclock.caption1" defaultMessage="Overclock your ASIC chips, which can't be done on the stock firmware." /></div>
        <div><FormattedMessage id="Overclock.caption2" defaultMessage="The auto-tuning script will re-configure each chip's clock speeds for the best result with minimum effort." /></div>
      </div>
    </div>
  </section>
)

export default Overclock;
